import React from 'react'
import styled from 'styled-components'
import { Block } from '@mote/ui'

export const Card = ({ children, ...rest }) => {
  return (
    <Root layout='vertical' align='center' justify='center' {...rest}>
      {children}
    </Root>
  )
}

const Root = styled(Block)`
  position: relative;
  padding: 24px;
  min-height: 150px;
  background: #ffffff;
  border-radius: 8px;

  @media (max-width: 639px) {
    min-height: 60px;
    padding: 16px;
  }
`
